export const H3Fields = [
    { identifier: 'font-size-h3', type: 'input', field: 'font-size-h3' },
    { identifier: 'font-weight-h3', type: 'input', field: 'font-weight-h3' },
    { identifier: 'font-color-h3', type: 'input', field: 'font-color-h3' }
]
